import { render, staticRenderFns } from "./SingleBdoCardTemplate.vue?vue&type=template&id=150f2926&"
import script from "./SingleBdoCardTemplate.vue?vue&type=script&lang=js&"
export * from "./SingleBdoCardTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports